import zwitCore from "./config/http";

const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
    // 收货地址
    getByUserList(params) {
        return zwitCore.HTTP.get(BASE_URL + "/zw-user/sysUserAddress/getByUserId", params, false);
    },
    // 保存
    setSave(params) {
        return zwitCore.HTTP.postJsonData(BASE_URL + "/zw-user/sysUserAddress/save", params, false);
    },
    // 省市区镇联动
    getRegion(params) {
        return zwitCore.HTTP.get(BASE_URL + "/zw-user/sysUserAddress/getRegion", params, false);
    },
    // 页面回显
    getEcho(params) {
        return zwitCore.HTTP.get(BASE_URL + "/zw-user/sysUserAddress/get", params, false);
    },
    // 删除收货地址
    setdelete(params) {
        return zwitCore.HTTP.postJsonData(BASE_URL + "/zw-user/sysUserAddress/delete", params, false);
    },
};